import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { DepartmentPage } from '@features/groups/components/pages/DepartmentPage'
import { createFileRoute } from '@tanstack/react-router'
import { Suspense } from 'react'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { departmentQueryOptions, groupsQueryOptions } from '@features/groups/queries'

export const Route = createFileRoute('/_layout/_teacher-portal/groups/department/$departmentId/')({
    component: RouteComponent,
    loader: async ({ params, context }) => {
        context.queryClient.ensureQueryData(departmentQueryOptions({ mode: 'id', id: params.departmentId }))
        context.queryClient.ensureQueryData(groupsQueryOptions({ mode: 'id', identifier: params.departmentId, type: 'programme' }))
        return null
    }
})

function RouteComponent() {
    return (
        <QueryErrorBoundary title='Failed to load department'>
            <Suspense fallback={<LoadingIndicator resource='department' />}>
                <DepartmentPage mode='id' navMode='id' id={Route.useParams().departmentId} />
            </Suspense>
        </QueryErrorBoundary>
    )
}
